// Library Methods
import axios from "axios";

// Utils
import { config, webServiceUrl } from "src/utils/services/servicesHelper";

// Types
import { UserSettingsType } from "./types";

const getUserSettings = async (
  accessToken: string | null
): Promise<UserSettingsType> => {
  try {
    const { data } = await axios.get(
      `${webServiceUrl}/me/user-settings`,
      config(accessToken)
    );
    return data?.data;
  } catch (error) {
    throw error;
  }
};

const updateUserSettings = async (
  accessToken: string | null,
  newUserSettings: UserSettingsType
): Promise<UserSettingsType> => {
  try {
    const { data } = await axios.put(
      `${webServiceUrl}/me/user-settings`,
      newUserSettings,
      config(accessToken)
    );
    return data?.data;
  } catch (error) {
    throw error;
  }
};

export { getUserSettings, updateUserSettings };
